// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"SceneWrapper_canvasContainer__2zk6v"};